import { IconTextButton } from "Components/Button";
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import { useEffect, useState } from "react";
import { Badge, Nav, Row, Tab, Table } from "react-bootstrap";
import { GetCompareCheckboxInputData } from "./RepoFormFields";
import { ACTIONS } from "Components/Forms/FormReducers/CheckboxInputReducer";
import { http } from "Utils";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { useDispatch } from "react-redux";
import { config } from "Utils/config";
import CompareModalLegend from "./CompareModalLegend";

// Compare modal for CF Repo data elements
// - Can be modified to compare additional versions if desired

function CompareModal({ setShowCompareModal, showCompareModal, de_name, de_id, commonFormatsList, tabActiveKey}) {
    const [verDeData, setVerDeData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [tableVer, setTableVer] = useState(tabActiveKey);
    const [showAdditional, setShowAdditional] = useState(false);

    var [versions, versionsInputDispatch] = GetCompareCheckboxInputData('versions', null);

    const dispatch = useDispatch();

    // Get DE info for H1.2 and H2.0
    useEffect(()=>{
        // H2.0
        getDe(444,de_id).then(()=>{
            //H1.2
            getDe(443,de_id).then(()=>{
                setCompareVersions();
                setIsLoading(false);
            });
        });
    },[])

    // Gets version name by id (used when there is no equivalent DE)
    const getCFVersionNameById = (verId) => {
        if(commonFormatsList!=null){
            var cfList = commonFormatsList;
            var ver = cfList.find(v => v.id == verId);

            if(ver!=null){
                return ver.name;
            }
            else{
                return null;
            }
        }
        else{
            return "";
        }
    }

    // Get DE compare data for single CF version
    const getDe = async (versionId, code) => {
        setIsLoading(true);

        const call = async () => {
            var url = "/api/cfRepo/deDetail";
            return http.post(url, {
                versionId: versionId,
                deCode: code.trim()
            });
        }
        return call().then((res) => {
            // Response status is not 1
            if (res.status != 1) {
                // No DE in version
                if(res.status==-3){
                    // Set version DE data as null (indicating no equivalent element)
                    setVerDeData((state)=>({
                        ...state,
                        [versionId]: null
                    }))
                }
                // Other error codes
                else{
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: res.globalErrorMessageList != null && res.globalErrorMessageList.length>0 ? res.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
            }
            // Set version DE data
            else {
                setVerDeData((state)=>({
                    ...state,
                    [versionId]: res.data
                }))
            }
            return res;
        }).catch((error)=>{
            config.isDebugEnabled && console.error(error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                }
            });
        });
    }

    // Get checked values from compare version list
    const inCompareVersionList = () => {
        var res = (versions.getValue(versions.checkBoxes));

        if(res!=null){
            return res;
        }
        else{
            return [];
        }
    }

    // Sets versions to compare (H1.2 and H2.0)
    const setCompareVersions = () =>{
        var versions = [];
        
        for(var x = 0 ; x < commonFormatsList.length ; x++){
            var ver = commonFormatsList[x];

            //Only include if H1.2 or H2.0
            if(ver.id==444 || ver.id==443){
                versions.push({
                    id: ver.id,
                    value: ver.id,
                    name: ver.id,
                    title: null,
                    displayValue: ver.name,
                    isChecked: (ver.name).startsWith("H") ? true : false,
                    label: ver.name
                })
            }
        }
        
        versionsInputDispatch({
            type: ACTIONS.CHECK_UPDATE_CHOICES,
            options: versions
        })
    }

    // Check if answers match
    // - answer: single answer to compare to answer values in cMap
    const answerMatches = (answer, cMap) =>{
        if(cMap!=null && cMap.hasOwnProperty(answer.answerCode)){
            config.isDebugEnabled && console.log("Code: ", answer.answerCode, "Matches: ", cMap[answer.answerCode]==answer.answerValue);
            
            // If values match
            if(cMap[answer.answerCode]==answer.answerValue){
                return true;
            }
        }

        return false;
    }

    // Get Answer Value cell for CF version
    const displayAnswerCell = (answers, compareAnswers) =>{
        config.isDebugEnabled && console.log("displayAnswerCell - ", answers, compareAnswers);

        var cMap = {};
        if(compareAnswers!=null){
            cMap = Object.fromEntries(compareAnswers.map(a => [a.answerCode, a.answerValue]));
            config.isDebugEnabled && console.log("CMap",cMap);
        }
        if(answers!=null){
            const answerMap = Object.fromEntries(answers.map(a => [a.answerCode, a.answerValue]));
            config.isDebugEnabled && console.log("AnswerMap",answerMap);
        }

        return (
            <td className="answer-td p-0">
                <div className="d-flex flex-column">
                {
                    answers!=null && answers.length > 0
                    ?
                        // Display answer values with appropriate styles
                        answers.map(answer => {
                            return (
                                <div className={compareAnswers==null || answerMatches(answer,cMap)==true ? "p-3" : "differs p-3"}>
                                    <p className={compareAnswers==null || answerMatches(answer,cMap)==true ? "mb-0" : "differs-content mb-0"}>
                                        {answer.answerCode} - {answer.answerValue}
                                    </p>
                                </div>
                            )
                        })
                    :   
                        // If there are no answers for Version DE, display NA
                        <div className={"p-3"}>
                            <p className="mb-0">NA</p>
                        </div>
                }
                </div>
            </td>
        )
    }

    const getCellData = (dataElements, dataKey, verId) =>{
        config.isDebugEnabled && console.log(tabActiveKey, dataKey, dataElements, verId);
        
        // DE data for selected version
        var compareData = dataElements[tabActiveKey];
        
        config.isDebugEnabled && console.log(tabActiveKey, compareData);

        // If only a single version's data is to be shown (Mobile)
        if(verId!=null){
            // DE data for version with verId
            var indivVerDEData = { [verId]: dataElements[verId]};
            
            return (
                <>
                    {
                        // For entries in indivVerDEData (which should only have 1 entry)
                        Object.entries(indivVerDEData).map(([version,value])=>{
                            config.isDebugEnabled && console.log(indivVerDEData, dataElements);

                            //var value = dataElements[version];

                            // If both versions have attribute data
                            if(value!=null && compareData!=null ){
                                if((inCompareVersionList()).includes(Number(version))){
                                    // If data is answer values and the answer value attributes for compareData and value are not null
                                    if(dataKey=="deAnswers" && value[dataKey]!=null && compareData!=null && compareData[dataKey]!=null){
                                        return (
                                            // Get answer value table for cell
                                            displayAnswerCell(value[dataKey],compareData[dataKey])
                                        )
                                    }
                                    // If data is not answer values
                                    else{
                                        // If attribute values match
                                        if(compareData!=null && ((compareData[dataKey]==null && value[dataKey]==null ) || ((compareData[dataKey]!=null && value[dataKey]!=null) && (compareData[dataKey]).trim()==(value[dataKey]).trim()))){
                                            return (
                                                <td>
                                                    {
                                                        value[dataKey]==null || value[dataKey]=="" 
                                                        ?   'NA' 
                                                        :   value[dataKey]
                                                    }
                                                </td>
                                            )
                                        }
                                        // If values don't match
                                        else{
                                            return (
                                                <td className="differs">
                                                    <div className={"differs-content " + (value[dataKey]!=null ? "" : "empty")}> 
                                                        {
                                                            value[dataKey]==null || value[dataKey]=="" 
                                                            ?   'NA' 
                                                            :   value[dataKey]
                                                        }
                                                    </div>
                                                </td>
                                            )
                                        }
                                    }
                                }
                            }
                            // If version DE data is null, show no equivalent element
                            else{
                                if((inCompareVersionList()).includes(Number(version))){
                                    return (
                                        <td className="no-match">
                                            <div className="no-match-content"> 
                                                No equivalent element
                                            </div>
                                        </td>
                                    )
                                }
                            }
                        })
                    }
                </>
            )
        }
        // If multiple version columns are shown at once
        else {
            return (
                <>
                    {
                        // If value of compareData is not null
                        compareData!=null
                        ?   
                            // If data is answer values
                            dataKey!=null && dataKey=="deAnswers" 
                            ?   
                                // Get answer value table for cell
                                displayAnswerCell(compareData[dataKey])
                            :   
                                // If value is blank or null
                                <td>
                                    {
                                        compareData[dataKey]==null || compareData[dataKey]=="" 
                                        ?   'NA' 
                                        :   compareData[dataKey]
                                    }
                                </td>
                        :   
                            // If no comparison data, show no equivalent element
                            <td className="no-match">
                                <div className="no-match-content"> 
                                    No equivalent element
                                </div>
                            </td>
                    }
                    
                    {
                        // Add other version columns
                        Object.entries(verDeData).map(([version,value])=>{
                            var value = dataElements[version];

                            if(value!=null && compareData!=null ){
                                // If not currently selected version
                                if(version!=tabActiveKey && (inCompareVersionList()).includes(Number(version))){
                                    
                                    config.isDebugEnabled && console.log(dataKey,compareData,value);
                                    
                                    // If data is answer values and the answer value attributes for compareData and value are not null
                                    if(dataKey=="deAnswers"&& value[dataKey]!=null && compareData!=null && compareData[dataKey]!=null){
                                        return (
                                            // Get answer value table for cell
                                            displayAnswerCell(value[dataKey],compareData[dataKey])
                                        )
                                    }
                                    // If data is not answer values
                                    else{
                                        // If attribute values match
                                        if(compareData!=null && ((compareData[dataKey]==null && value[dataKey]==null ) || ((compareData[dataKey]!=null && value[dataKey]!=null) && (compareData[dataKey]).trim()==(value[dataKey]).trim()))){
                                            return (
                                                <td>
                                                    {
                                                        value[dataKey]==null || value[dataKey]=="" 
                                                        ?   'NA' 
                                                        :   value[dataKey]
                                                    }
                                                </td>
                                            )
                                        }
                                        // If values don't match
                                        else{
                                            return (
                                                <td className="differs">
                                                    <div className={"differs-content " + (value[dataKey]!=null ? "" : "empty")}> 
                                                        {
                                                            value[dataKey]==null || value[dataKey]=="" 
                                                            ?   'NA' 
                                                            :   value[dataKey]
                                                        }
                                                    </div>
                                                </td>
                                            )
                                        }
                                    }
                                }
                            }
                            else{
                                config.isDebugEnabled && console.log(version, (inCompareVersionList()).includes(version));
                                
                                if((inCompareVersionList()).includes(Number(version))){
                                    // If no comparison data, show no equivalent element
                                    return (
                                        <td className="no-match">
                                            <div className="no-match-content"> 
                                                No equivalent element
                                            </div>
                                        </td>
                                    )
                                }
                            }
                        })
                    }
                </>
            )
        }
    }

    // Get abbreviated version name
    const getVersionAbbr = (versionId) =>{
        if(versionId==443){
            return "Hosp v1.2";
        }
        if(versionId==444){
            return "Hosp v2.0";
        }
    }
    
    return (
        <Row id="compare-popup" >
            <DynamicFormPopup
                showPopup = {showCompareModal}
                handleClose = {()=>setShowCompareModal(false)}
                buttons = {[{
                    text: "Close",
                    action: ()=>setShowCompareModal(false),
                    variant: "comp-primary",
                    size: "lg",
                    className: "m-0 close-compare-btn w-xs-100 w-md-fit-content"
                }]}
                title = {"Compare Data Element"}
                type= {"blank"}
                variant={"blank"}
                id="compare-popup compare-modal"
                size="xl"
                closeVar="repo"
                scrollable={false}
            >
                <>  
                    <div className="px-32px px-md-0 ">       
                        <p className="color-base-darkergray">Comparing <b>{de_id} - {de_name}</b> between Hospital 1.2 and Hospital 2.0. Cells highlighted in yellow differ from the selected version. Versions where this element does not exist are indicated.</p>
                        <CompareModalLegend></CompareModalLegend>
                    </div>  

                    <Tab.Container
                        id="controlled-tab-example"
                        activeKey={tableVer}
                        onSelect={(k) => setTableVer(k)}
                        className="mb-3"
                    >
                        {/* MOBILE - Tabbed navigation for switching between versions*/}
                        <Nav variant="tabs" justify className="d-flex d-md-none compare-versions mx-1">
                            {/* Add Selected Version tab */}
                            {
                                Object.entries(verDeData).map(([version,value])=>{
                                    if(version==tabActiveKey){
                                        return (
                                            <Nav.Item>
                                                <Nav.Link className="gap-2" eventKey={version} ><div>{getVersionAbbr(version)}</div><Badge bg="" className="">Selected</Badge></Nav.Link>
                                            </Nav.Item>
                                        )
                                    }
                                })
                            }

                            {/* Add all other version tabs */}
                            {
                                Object.entries(verDeData).map(([version,value])=>{
                                    if(version!=tabActiveKey && (inCompareVersionList()).includes(Number(version))){
                                        return (
                                            <Nav.Item>
                                                <Nav.Link eventKey={version}><div>{getVersionAbbr(version)}</div></Nav.Link>
                                            </Nav.Item>
                                        )
                                    }
                                })
                            } 
                        </Nav>
                    
                        {
                            isLoading!=true 
                            ?
                                <>
                                    <div className="comparison-table-container d-flex flex-column">
                                        <div className="comp-table-div mx-1">
                                            <Table>
                                                <thead >
                                                    <tr className="d-none d-md-table-row">
                                                        {/* Empty top left cell */}
                                                        <td className="fixed-col empty"></td>

                                                        {/* Add Selected Version column header */}
                                                        {
                                                            Object.entries(verDeData).map(([version,value])=>{
                                                                // If current version
                                                                if(version==tabActiveKey){
                                                                    return (
                                                                        <th className="selected-ver">
                                                                            <div className="col-title">
                                                                                <div>{value.versionName}</div>
                                                                                <div className="selected-ver-indic">Selected Version</div>
                                                                            </div>
                                                                        </th>
                                                                    )
                                                                }
                                                            })
                                                        }

                                                        {/* Add all other version column headers */}
                                                        {
                                                            Object.entries(verDeData).map(([version,value])=>{
                                                                if(version!=tabActiveKey && (inCompareVersionList()).includes(Number(version))){
                                                                    return (
                                                                        <th>
                                                                            <div className="col-title">
                                                                                {value!=null && value.hasOwnProperty("versionName") ? value.versionName : getCFVersionNameById(version)}
                                                                            </div>
                                                                        </th>
                                                                    )
                                                                }
                                                            }
                                                        )}
                                                    </tr>
                                                </thead>
                                                
                                                {/* MOBILE ------------ */}

                                                
                                                <tbody className="d-table-row-group d-md-none">
                                                    {/* DE attribute comparison rows */}
                                                    <tr>
                                                        <th className="fixed-col">Data element ID</th>
                                                        {getCellData(verDeData,"deCode",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data element name</th>
                                                        {getCellData(verDeData,"deName",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data element question</th>
                                                        {getCellData(verDeData,"deQuestion",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Answer Value</th>
                                                        {getCellData(verDeData,"deAnswers",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Allowed to submit to PSOPPC</th>
                                                        {getCellData(verDeData,"deAllowSubmit",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Applicable NullFlavor</th>
                                                        {getCellData(verDeData,"deNullFlavor",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">CDA Header</th>
                                                        {getCellData(verDeData,"deCdaHeaderSection",tableVer)}
                                                    </tr> 
                                                </tbody>
                                                
                                                {/* Attributes whose visibility is toggleable */}
                                                <tbody className={showAdditional==false ? 'd-none ' : 'd-table-row-group d-md-none'}>
                                                    <tr>
                                                        <th className="fixed-col">HL7 data type</th>
                                                        {getCellData(verDeData,"deHl7DataType",tableVer)}
                                                    </tr>
                                                    <tr className="cdaElAttr">
                                                        <th className="fixed-col">CDA Element/Attribute</th>
                                                        {getCellData(verDeData,"deCdaElementAttribute",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Type of Representation</th>
                                                        {getCellData(verDeData,"deTypeOfPresentation",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Answer Value Set OID</th>
                                                        {getCellData(verDeData,"deAnswerValueSetOid",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Multiple Answer Values Allowed</th>
                                                        {getCellData(verDeData,"deMultipleChoice",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data Type</th>
                                                        {getCellData(verDeData,"deDataType",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Maximum Length</th>
                                                        {getCellData(verDeData,"deMaxLength",tableVer)}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Special Instruction</th>
                                                        {getCellData(verDeData,"deSpecialInstruction",tableVer)}
                                                    </tr>
                                                </tbody>


                                                {/* DESKTOP ------------ */}

                                                <tbody className="d-none d-md-table-row-group">
                                                    {/* DE attribute comparison rows */}
                                                    <tr>
                                                        <th className="fixed-col">Data element ID</th>
                                                        {getCellData(verDeData,"deCode")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data element name</th>
                                                        {getCellData(verDeData,"deName")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data element question</th>
                                                        {getCellData(verDeData,"deQuestion")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Answer Value</th>
                                                        {getCellData(verDeData,"deAnswers")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Allowed to submit to PSOPPC</th>
                                                        {getCellData(verDeData,"deAllowSubmit")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Applicable NullFlavor</th>
                                                        {getCellData(verDeData,"deNullFlavor")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">CDA Header</th>
                                                        {getCellData(verDeData,"deCdaHeaderSection")}
                                                    </tr> 
                                                </tbody>

                                                {/* Attributes whose visibility is toggleable */}
                                                <tbody className={showAdditional==false ? 'd-none ' : 'd-none d-md-table-row-group'}>
                                                    <tr>
                                                        <th className="fixed-col">HL7 data type</th>
                                                        {getCellData(verDeData,"deHl7DataType")}
                                                    </tr>
                                                    <tr className="cdaElAttr">
                                                        <th className="fixed-col">CDA Element/Attribute</th>
                                                        {getCellData(verDeData,"deCdaElementAttribute")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Type of Representation</th>
                                                        {getCellData(verDeData,"deTypeOfPresentation")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Answer Value Set Object Identifier (OID)</th>
                                                        {getCellData(verDeData,"deAnswerValueSetOid")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Multiple Answer Values Allowed</th>
                                                        {getCellData(verDeData,"deMultipleChoice")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Data Type</th>
                                                        {getCellData(verDeData,"deDataType")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Maximum Length</th>
                                                        {getCellData(verDeData,"deMaxLength")}
                                                    </tr>
                                                    <tr>
                                                        <th className="fixed-col">Special Instruction</th>
                                                        {getCellData(verDeData,"deSpecialInstruction")}
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>

                                        {/* View more/less attributes button. Toggles extra attribute visibility */}
                                        <IconTextButton 
                                            variant="comp-view-more"
                                            className="reverse d-flex justify-content-center view-more-btn mb-40px mb-md-0 mx-2 mx-md-0 "
                                            onClick={()=>setShowAdditional(!showAdditional)} 
                                            content={showAdditional==false ? 'View More' : 'View Less'}
                                            icon={()=>{
                                                return (<svg className={showAdditional==true ? "down-icon" : ""} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M16.59 8.29504L12 12.875L7.41 8.29504L6 9.70504L12 15.705L18 9.70504L16.59 8.29504Z" fill="#686E7A"/>
                                                        </svg>)
                                                }
                                            }
                                        >
                                        </IconTextButton>
                                    </div>
                                </>
                            :   null
                        }
                    </Tab.Container>
                </>
            </DynamicFormPopup>
        </Row>
    );
}

export default CompareModal;